<div class="invoice-import-settings">
  <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

  <nb-card class="mb-3">
    <nb-card-body>
      <div class="small text-muted">{{ 'INVOICE_IMPORTS.SETTINGS.INBOUND' | translate }}</div>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <code>{{ inboundAddress }}</code>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="copyInbound()">
          {{ 'INVOICE_IMPORTS.OVERVIEW.COPY' | translate }}
        </button>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card class="mb-3">
    <nb-card-header>{{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_STOCK_TITLE' | translate }}</nb-card-header>
    <nb-card-body>
      <div class="alert alert-danger small" *ngIf="transportLoadError">{{ transportLoadError }}</div>
      <div class="table-responsive" *ngIf="transportBalances.length">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_CODE' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_LABEL' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_BALANCE' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_LAST' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of transportBalances">
              <td>{{ item.itemCode }}</td>
              <td>{{ item.label }}</td>
              <td>{{ item.balance }}</td>
              <td>{{ item.lastMovementAt | date:'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="small text-muted mb-0" *ngIf="!transportBalances.length && !transportLoadError">
        {{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_EMPTY' | translate }}
      </p>
    </nb-card-body>
  </nb-card>

  <div class="row g-3">
    <div class="col-md-6" *ngFor="let def of definitions">
      <nb-card>
        <nb-card-header class="d-flex justify-content-between align-items-center">
          <span>{{ def.displayName }} ({{ def.supplierKey }})</span>
          <span class="badge" [class.bg-success]="configFor(def.supplierKey)?.isActive" [class.bg-secondary]="!configFor(def.supplierKey)?.isActive">
            {{ configFor(def.supplierKey)?.isActive ? ('INVOICE_IMPORTS.SETTINGS.ACTIVE' | translate) : ('INVOICE_IMPORTS.SETTINGS.INACTIVE' | translate) }}
          </span>
        </nb-card-header>
        <nb-card-body>
          <p class="small text-muted">{{ def.description }}</p>
          <div *ngIf="configFor(def.supplierKey) as cfg">
            <div class="small" *ngFor="let key of (cfg.routing | keyvalue)">
              <strong>{{ key.key }}:</strong> {{ key.value }}
            </div>
            <div class="small mt-2" *ngIf="cfg.approvedFromAddresses?.length">
              {{ 'INVOICE_IMPORTS.SETTINGS.APPROVED_SENDERS' | translate }}:
              <span class="badge bg-light text-dark me-1" *ngFor="let a of cfg.approvedFromAddresses">{{ a }}</span>
            </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button type="button" class="btn btn-sm btn-primary" (click)="openEditor(def)">
              {{ configFor(def.supplierKey) ? ('INVOICE_IMPORTS.SETTINGS.EDIT' | translate) : ('INVOICE_IMPORTS.SETTINGS.ADD' | translate) }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              *ngIf="configFor(def.supplierKey)?.isActive"
              (click)="deactivate(configFor(def.supplierKey)!)">
              {{ 'INVOICE_IMPORTS.SETTINGS.DEACTIVATE' | translate }}
            </button>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>
